import * as React from 'react';
import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';
import RectangleIcon from '../../../assets/images/Rectangle.js';



export default function CustomizedRating({color,defaultValue}) {
    const StyledRating = styled(Rating)({
        '& .MuiRating-iconFilled': {
          color,
        },
        '& .MuiRating-iconHover': {
          color: '#ff3d47',
        },
      });
  return (
      <StyledRating
      readOnly
        name="customized-color"
        defaultValue={defaultValue}
        getLabelText={(value) => `${value} Heart${value !== 1 ? 's' : ''}`}
        precision={0.5}
        icon={<RectangleIcon fontSize="inherit" />}
        emptyIcon={<RectangleIcon fontSize="inherit" />}
      />
  );
}